import React, { CSSProperties, ReactNode, forwardRef } from 'react';

interface TextProps {
  children?: ReactNode;
  className?: string;
  numberOfLines?: number;
  style?: CSSProperties;
  onPress?: React.MouseEventHandler<HTMLSpanElement>;
}

export const Text = forwardRef<HTMLSpanElement, TextProps>(
  ({ children, className = '', numberOfLines = '', onPress, style }, ref) => {
    const textStyle: CSSProperties = {
      ...(numberOfLines && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: numberOfLines,
        WebkitBoxOrient: 'vertical',
      }),
    };

    return (
      <span
        style={{ ...textStyle, ...style }}
        className={className}
        onClick={onPress ? onPress : undefined}
        ref={ref}
      >
        {children}
      </span>
    );
  }
);
